import { MessageCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

export const FloatingWhatsApp = () => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar no WhatsApp"
            data-testid="floating-whatsapp-button"
            className="fixed bottom-4 right-4 z-[var(--z-floating)] flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-[0_14px_40px_rgba(20,16,12,0.22)] transition-[background-color,transform] duration-200 hover:bg-primary/90 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:bottom-6 sm:right-6"
          >
            <span
              aria-hidden="true"
              className="absolute inset-0 -z-10 rounded-2xl bg-[hsl(var(--brand-champagne-gold))]/40 blur-md"
            />
            <MessageCircle className="h-6 w-6" />
          </a>
        </TooltipTrigger>
        <TooltipContent side="left" className="rounded-xl border-border bg-card text-foreground">
          Falar no WhatsApp
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
